import { type SizeType } from 'antd/lib/config-provider/SizeContext';
import React, { type ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
  min-height: 53px;
  padding: 10px;
`;

const ActionButtonsContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`;

interface TitleLabelProps {
  $size?: SizeType;
}

const sizeTypeToFontSize = {
  small: '14px',
  middle: '17px',
  large: '20px',
} as const;

const TitleLabel = styled.h1<TitleLabelProps>`
  font-size: ${(p) => sizeTypeToFontSize[p.$size || 'large']};
  font-weight: 600;
  margin: 0;
  align-self: center;
`;

export interface TableHeaderProps {
  actionButtons?: ReactNode | undefined;
  size?: SizeType;
  title?: string;
}

function TableHeader({ actionButtons, size, title }: TableHeaderProps) {
  return (
    <Container>
      <TitleLabel $size={size}>{title}</TitleLabel>
      <ActionButtonsContainer>{actionButtons}</ActionButtonsContainer>
    </Container>
  );
}

export default TableHeader;
